export enum Hashs {
    EDIT = 'edit',
    CREATE = 'create',
    DETAIL = 'detail'
}